import { environment } from 'src/environments/environment'

const baseUrl = environment.baseUrl;
export const UnAauthenticateApis = [
    `${baseUrl}/user/me/forgotpassword`,
    `${baseUrl}/user/me/resetpassword`,
    `${baseUrl}/user/invite/accept`,
    `${baseUrl}/user/me/verifytoken`,
    `${baseUrl}/prestogateway/confirm/token/txnRefNum`,
];
export const invitedUserUrl:string = `${baseUrl}/user/invite`;

export const CUSTOME_API_TIME_OUT = [
    `${baseUrl}/consignment/bulk/create`
];
